export type TopicMessageCallback = (message: string | Buffer) => void;

export type TopicSubscribersMap = Map<string, Set<TopicMessageCallback>>;

export function getTopics(topic: string | string[]) {
  return Array.isArray(topic) ? topic : [topic];
}

export function notifyTopicSubscribers(
  topicSubscribers: TopicSubscribersMap,
  topic: string,
  message: Buffer,
) {
  const subscribers = topicSubscribers.get(topic);

  subscribers?.forEach((callback) => {
    callback(message);
  });
}

export function addTopicSubscriber(
  topicSubscribers: TopicSubscribersMap,
  topic: string,
  callback: TopicMessageCallback,
) {
  const existingSubscribers = topicSubscribers.get(topic);

  if (existingSubscribers) {
    existingSubscribers.add(callback);
    return false;
  }

  topicSubscribers.set(topic, new Set([callback]));
  return true;
}

export function removeTopicSubscriber(
  topicSubscribers: TopicSubscribersMap,
  topic: string,
  callback?: TopicMessageCallback,
) {
  const subscribers = topicSubscribers.get(topic);

  if (!subscribers) {
    return false;
  }

  if (callback) {
    subscribers.delete(callback);
  } else {
    subscribers.clear();
  }

  if (subscribers.size) {
    return false;
  }

  topicSubscribers.delete(topic);
  return true;
}
